















































































































import { Component, Prop, Watch, Emit, Mixins } from 'vue-property-decorator';

import ModelSetter from "../../../Mixins/ModelSetter";
import SelectInput from "../../../components/Pi/fields/SelectInput/SelectInput.vue";
import TextInput from "../../../components/Pi/fields/TextInput/TextInput.vue";
import PiTabs from "../../../components/PiTabs.vue";
import { SelectOption } from '../../../logic/types';
import {
  ApplicationJson, ApplicationXml, ContentType, REQUEST_HEADER_VALUES,
  REQUEST_HEADERS, TextPlain, UrlEncoded, XML_MIME_TYPES,
  FormData, PLAIN_MIME_TYPES
} from '../../logic/HttpRequest/constants';
import { HttpRequest } from "../../types/HttpRequest";
import HttpRequestJson from "./HttpRequestJson.vue";
import HttpRequestTypePopover from "./HttpRequestTypePopover.vue";
import RecordFillFields from "./RecordFillFields.vue";
import { AvailableBaseTabs } from './types';

@Component({
  components: {
    TextInput,
    PiTabs,
    SelectInput,
    HttpRequestTypePopover,
    RecordFillFields,
    HttpRequestJson
  }
})
export default class HttpRequestSetting extends Mixins(ModelSetter) {
  @Prop() request!: HttpRequest

  @Prop() httpMethods!: Array<SelectOption>

  @Prop() requestFormatOptions!: Array<SelectOption>

  @Prop() tabs!: Array<SelectOption>

  @Prop() responseTypeOptions!: Array<SelectOption>

  requestValue: HttpRequest | null = null

  @Watch('requestValue', { deep: true })
  onRequestChange(value: HttpRequest) {
    this.input(value)
  }

  @Emit()
  input(value: HttpRequest) {
    return value
  }

  currentTab: AvailableBaseTabs = AvailableBaseTabs.body

  bodyKey = 0

  get requestFormat() {
    if (this.requestValue?.headers) {
      if (this.hasFormHeader(this.requestValue.headers)) {
        return [ 'form' ]
      } else if (this.hasXMLHeader(this.requestValue.headers)) {
        return [ 'xml' ]
      } else if (this.requestValue.headers?.[ContentType] === ApplicationJson) {
        return [ 'json' ]
      } else if (PLAIN_MIME_TYPES.includes(this.requestValue.headers[ContentType])) {
        return [ 'plain' ]
      }
    }

    return []
  }

  set requestFormat([ key ]: Array<'json' | 'xml' | 'form' | 'plain'>) {
    let contentTypeValue = ''

    if (key === "json") {
      contentTypeValue = ApplicationJson
    } else if (key === "form") {
      contentTypeValue = FormData
    } else if (key === "xml") {
      contentTypeValue = ApplicationXml
    } else if (key === "plain") {
      contentTypeValue = TextPlain
    }

    this.headers = {
      ...this.headers,
      [ContentType]: contentTypeValue
    }
  }

  get headers() {
    return this.requestValue?.headers ?? {}
  }

  set headers(value: Record<string, string>) {
    if (this.requestValue) {
      if (value[ContentType] !== this.requestValue.headers?.[ContentType]) {
        if (this.hasFormHeader(value) || this.hasXMLHeader(value)) {
          this.requestValue.body = ''
          this.requestValue.form = {}
        } else if (value[ContentType] === ApplicationJson) {
          this.requestValue.body = '{\n\n}'
          this.requestValue.form = null
        } else {
          this.requestValue.body = ''
          this.requestValue.form = null
        }
      }

      this.requestValue.headers = value
    }
  }

  hasXMLHeader(headers: Record<string, string>) {
    return XML_MIME_TYPES.includes(headers[ContentType])
  }

  getBodyLanguageByHeaders() {
    if (this.hasXMLHeader(this.headers)) {
      return 'xml'
    } else if (this.headers[ContentType] === TextPlain) {
      return 'plaintext'
    } else {
      return 'json'
    }
  }

  hasFormHeader(headers: Record<string, string>) {
    return headers[ContentType] === FormData || headers[ContentType] === UrlEncoded
  }

  get filteredRequestHeaders() {
    return REQUEST_HEADERS.filter(k => !this.requestValue?.headers?.[k])
  }

  getHeaderValueOptions(key: string) {
    return REQUEST_HEADER_VALUES?.[key] ?? []
  }

  created() {
    this.requestValue = { ...this.request }
  }
}
